export default __webpack_public_path__ + "static/media/team_5.b691c16f.jpg";